import { connect } from 'react-redux';
import EventsList from '../components/events_list';
import { commitEvents } from '../actions/leaderboardV2_index';
import { fullClearEventSlice, fetchResultScope } from '../actions/event_index';
import { fetchSummary, clearSummaries } from '../actions/summaries_index';
import { selectIsManagerSite, selectOpenSummaryKey } from '../selectors';
import { isSummariesOnlyRound } from '../utils/events_utils';

const mapStateToProps = (state) => ({
  eventsList: state.leaderboardV2.eventsList,
  favoritesByEvent: state.leaderboardV2.favoritesByEvent,
  selectedEventId: Object.keys(state.event)?.[0] || null,
  selectedSummaryKey: selectOpenSummaryKey(state),
  isManagerSite: selectIsManagerSite(state),
  isMultiRound: state.leaderboardV2.roundList.length > 1,
  // Spinner only when there is nothing truthful to display: the held list
  // belongs to a round the user has left, or nothing has ever loaded. A
  // known-empty round (emptyEventsList, stamped atomically with the list for
  // the same round) IS truthful - without that term, the empty state would
  // flicker into a spinner whenever anything refetches the list (e.g. the
  // Select a Different Round button opening the rounds modal).
  isLoadingList:
    state.leaderboardV2.loading &&
    (String(state.leaderboardV2.eventsListRoundId) !== String(state.leaderboardV2.roundId) ||
      (Object.keys(state.leaderboardV2.eventsList).length === 0 && !state.leaderboardV2.emptyEventsList)),
  // No !loading term: like the event tiles, the message is previous truthful
  // state and persists through a refetch (stale-while-revalidate) - hiding it
  // would flicker it out whenever anything refetches the list (e.g. the
  // mobile modal open).
  showEmptyState:
    state.leaderboardV2.emptyEventsList &&
    !state.leaderboardV2.error &&
    !isSummariesOnlyRound(state.leaderboardV2.roundList, state.leaderboardV2.roundId),
  // Booting with no round at all means every round is hidden from the portal
  // (not started or results not released) - a different message from a real
  // round that simply has no tournaments.
  resultsNotReleased: !state.leaderboardV2.roundId,
});

const mapDispatchToProps = (dispatch) => ({
  commitEvents: (roundId, eventsList) => dispatch(commitEvents(roundId, eventsList)),
  fullClearEventSlice: () => dispatch(fullClearEventSlice()),
  fetchResultScope: (eventId, options) => dispatch(fetchResultScope(eventId, options)),
  fetchSummary: (summaryKey) => dispatch(fetchSummary(summaryKey)),
  clearSummaries: () => dispatch(clearSummaries()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventsList);
